import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

type ClientEquipment = {
	brand?: string | null;
	model?: string | null;
};

type RepairSummary = {
	repairNumber?: string | number | null;
	clientEquipment?: ClientEquipment | null;
};

type CommissionReturnEntry = {
	repair?: RepairSummary | null;
	value?: number | null;
};

type CommissionsReturnsTableProps = {
	commissions?: CommissionReturnEntry[];
};

const formatEquipmentLabel = (equipment?: ClientEquipment | null) => {
	if (!equipment) {
		return "-";
	}

	const brand = equipment.brand?.trim() ?? "";
	const model = equipment.model?.trim() ?? "";
	const label = `${brand} ${model}`.trim();
	return label.length > 0 ? label : "-";
};

const formatValue = (value: number | null | undefined) => {
	const normalized = Number(value ?? 0);
	return `${normalized.toFixed(3)}€`;
};

export function CommissionsReturnsTable({
	commissions = [],
}: CommissionsReturnsTableProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead>#</TableHead>
						<TableHead>Equipamento</TableHead>
						<TableHead>Valor a Devolver</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{commissions.map((entry) => {
						const repairNumber = entry.repair?.repairNumber ?? "-";
						const equipmentLabel = formatEquipmentLabel(
							entry.repair?.clientEquipment,
						);
						const rowKey = `${repairNumber}-${equipmentLabel}`;

						return (
							<TableRow key={rowKey}>
								<TableCell>{repairNumber}</TableCell>
								<TableCell>{equipmentLabel}</TableCell>
								<TableCell>{formatValue(entry.value)}</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
